import React, { Component } from 'react'

import {

  Button,

  message,

} from 'antd'
import { connect } from 'react-redux';
import Richtextbox from "../../components/Richtextbox"
import { FirebaseRef } from '../../lib/firebase'
class Detail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      content: "",
    }
    this.tmpContent = ""

  }
  componentDidMount() {
    const id = this.props.match.params.id
    const ref = FirebaseRef.child(`/${id}`)

    ref.on('value', snapshot => {
      const data = snapshot.val() || {}

      if (data.content) {
        this.setState({
          content: data.content,

        })
        this.tmpContent = data.content
      } else {
        this.setState({
          content: '',

        })
        this.tmpContent = ''
      }
    })
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match.params.id
    if (id !== prevProps.match.params.id) {
      const ref = FirebaseRef.child(`/${id}`)

      ref.on('value', snapshot => {
        const data = snapshot.val() || {}

        if (data.content) {
          this.setState({
            content: data.content,

          })
          this.tmpContent = data.content
        } else {
          this.setState({
            content: '',

          })
          this.tmpContent = ''
        }
      })
    }
  }

  updateContent(value) {

    this.tmpContent = value
  }



  onSubmit() {
    const id = this.props.match.params.id

    FirebaseRef.child(`/${id}`)
      .set({
        content: this.tmpContent
      })
      .then(() => {
        message.success("Content save successfully!")
        this.setState({
          content: this.tmpContent
        })
      })
      .catch(err => {
        message.err("Something was wrong !")
      })
  }

  render() {
    const { content } = this.state


    return (
      <div className="Place" >

        <Richtextbox content={content} updateConten={(value => (this.updateContent(value)))} />

        <Button style={{ marginTop: '20px' }} onClick={() => { this.onSubmit() }} type="primary">
          Save
        </Button>


      </div>
    )
  }

}



function mapDispatchToProps() {
  return {

  }
}

export default connect(null, mapDispatchToProps)(Detail);
